import React, {useContext, useEffect, useState} from 'react';
import MyTable from "../core/Components/MyTable";
import IconButton from "../IconButton";
import {faPlus, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import {SalvoContext} from "../../contexts/SalvoContext";
import {
    getGlobalNotificationSubscribers,
    getNotificationSubscriptionsForCompany,
    unsubscribeFromGlobalNotifications,
    unsubscribeFromNotificationsForCompany
} from "../../API/companyApi";
import {toast} from "react-toastify";
import messageFromError from "../../utils/errorUtils";
import ConditionalRender from "../ConditionalRender";
import LoadingTableSpinner from "../Loading/LoadingTableSpinner";
import {useTranslation} from "react-i18next";
import {displayNameForLanguageCode} from "../../utils/utils";
import AddNotificationSubscriberModal from "../Modals/ActionModals/AddNotificationSubscriberModal";
import useMyTranslation from "../../Hooks/useMyTranslation";
import ActionModal from "../Modals/ActionModals/ActionModal";

const NotificationSettings = () => {

    const {selectedCompany} = useContext(SalvoContext);
    const t = useMyTranslation('pages.settings')
    const {t:tOrig} = useTranslation()

    const [subscribers, setSubscribers] = useState()
    const [emailToUnsubscribe, setEmailToUnsubscribe] = useState(null);
    const [showAddSubscriberModal, setShowAddSubscriberModal] = useState(false);

    async function fetchSubscribers() {
        if(selectedCompany) {
            try {
                const response = await getNotificationSubscriptionsForCompany(selectedCompany.id);
                setSubscribers(response.data);
            } catch (err) {
                toast.error(messageFromError(err))
            }
        }
        else {
            // fetch global subscribers
            try {
                const response = await getGlobalNotificationSubscribers()
                setSubscribers(response.data)
            }
            catch (err)
            {
                toast.error(messageFromError(err))
            }
        }
    }

    useEffect(() => {
        fetchSubscribers();
    }, [selectedCompany]);

    async function unsubscribeFromNotifications() {
        if (selectedCompany)
        {
            await unsubscribeFromNotificationsForCompany(selectedCompany.id, emailToUnsubscribe);
        }
        else
        {
            await unsubscribeFromGlobalNotifications(emailToUnsubscribe);
        }

        await fetchSubscribers()
    }

    return (
        <div className={'px-2'}>
            <div className={'mb-2 d-flex justify-content-between align-items-center'}>
                <p className={'mb-0'}>{t('notificationsTabDescription')}</p>
                <div><IconButton icon={faPlus} color="white" bg="#198754" onClick={() => setShowAddSubscriberModal(true)}/></div>
            </div>
            <MyTable hover={false} responsive style={{tableLayout: 'auto'}}>
                <thead>
                <tr>
                        <th>{t('email')}</th>
                        <th>{t('label')}</th>
                        <th>{t('language')}</th>
                        <th>{t('actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    <ConditionalRender condition={!subscribers}>
                        <LoadingTableSpinner variant={'primary'} columns={4} small/>
                    </ConditionalRender>
                    <ConditionalRender condition={subscribers?.length < 1}>
                        <tr>
                            <td colSpan={4} className={'py-3 text-muted'}>
                                {t('noSubscribers')}
                            </td>
                        </tr>
                    </ConditionalRender>
                    {subscribers?.map(sub => {
                        return (
                            <tr key={sub.email}>
                                <td style={{maxWidth: '100%'}}>{sub.email}</td>
                                <td>{sub.label || '-'}</td>
                                <td>{displayNameForLanguageCode(sub.languageCode, tOrig)}</td>
                                <td><IconButton icon={faTrashCan} color={'red'} onClick={() => setEmailToUnsubscribe(sub.email)}/></td>
                            </tr>
                        )
                    })}
                </tbody>
            </MyTable>

            <AddNotificationSubscriberModal companyId={selectedCompany?.id} active={showAddSubscriberModal} hide={()=> setShowAddSubscriberModal(false)} onSuccess={fetchSubscribers}/>
            <ActionModal
                func={unsubscribeFromNotifications}
                active={emailToUnsubscribe}
                hideOnConfirm
                onCancel={() => {setEmailToUnsubscribe(null)}}
                title={t('title', 'dialogs.confirmDeleteDialog')}>

                {<span>{t('youAreAboutTo', 'dialogs.confirmDeleteDialog')} <strong style={{color: 'red', textTransform: 'lowercase'}}>{t('unsubscribeDialog.unsubscribe')}</strong> <strong>{emailToUnsubscribe}</strong>. {t('areYouSure', 'dialogs.confirmDeleteDialog')}</span>}
            </ActionModal>
        </div>
    );
};

export default NotificationSettings;